import qs from 'qs'

const queryString = {
	parse({ props: { location: { search = `` } = {} } = {} } = {}) {
		let obj = qs.parse(
			search.replace(/^\?/gi, ``),
			{ allowDots: true }
		)
		return obj
	},
	stringify(obj: any) {
		return qs.stringify(
			obj,
			{ encode: false, allowDots: true }
		)
	},
	push({ props: { history, location: { pathname } } }: any, str = ``) {
		history.push({
			pathname,
			search: str
		})
	},
	replace({ props: { history, location: { pathname } } }: any, str = ``) {
		history.replace({
			pathname,
			search: str
		})
	}
}

export default queryString